/** Dispatched on `window` so any component can trigger Header’s location flows without prop drilling. */
export const DANK_OPEN_DELIVERY_POSTAL_MODAL = 'dank-open-delivery-postal-modal';
export const DANK_OPEN_PICKUP_STORE_MODAL = 'dank-open-pickup-store-modal';

/** Dispatched whenever the unread-notification count changes (mark read,
 *  mark all read, refresh). Carries the authoritative new count so the
 *  Header's bell badge stays in sync with the /account notifications view
 *  without prop drilling or waiting for the 60s poll. */
export const DANK_NOTIFICATIONS_CHANGED = 'dank-notifications-changed';

export type NotificationsChangedDetail = { unreadCount: number };

/** Helper: fire the notifications-changed event with the new unread count.
 *  The dispatch is deferred to a microtask so listeners never run inside
 *  the caller's synchronous stack, e.g. a React render or a state-updater
 *  function, which would otherwise trigger a "setState while rendering a
 *  different component" error in any component listening for this event. */
export function emitNotificationsChanged(unreadCount: number): void {
  if (typeof window === 'undefined') return;
  const safe = Math.max(0, unreadCount);
  queueMicrotask(() => {
    window.dispatchEvent(
      new CustomEvent<NotificationsChangedDetail>(DANK_NOTIFICATIONS_CHANGED, {
        detail: { unreadCount: safe },
      })
    );
  });
}
